module.exports = __webpack_public_path__ + "assets/img/5.ce86f1ff.jpg";